import * as React from 'react';

import { Participant } from '../Participant';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { useStyles } from './ParticipantList.styles';
import { BlockWrapper } from 'components';
import { useBreakpoints } from "utils";

const ParticipantList = () => {
  const styles = useStyles();
  const { dataStore } = useStores();
  const { isMd } = useBreakpoints()

  return (
    <BlockWrapper mt={2.5} hasWrap={!isMd}>
      <ul className={styles.list}>
        {dataStore.appData?.participants.map((participant) => (
          <li className={styles.item} key={participant.participantId}>
            <Participant {...participant} key={participant.participantId} />
          </li>
        ))}
      </ul>
    </BlockWrapper>
  );
};

export default observer(ParticipantList);
